module.exports = __webpack_public_path__ + "static/media/down-arrow-icon.3f18026c.svg";